<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div
      id="kt_app_content_container"
      class="app-container container-fluid profile-page-container"
    >
      <div>
        <div class="card mb-5">
          <p
            *ngIf="currentPath === 'detail'"
            class="fs-6 text profile-header-text"
          >
            {{ "profile.myProfile" | translate }}
          </p>
          <p
            *ngIf="currentPath === 'info'"
            class="fs-6 text profile-header-text"
          >
            {{ "profile.info" | translate }}
          </p>
          <div class="profile-header-line" aria-hidden="true">
            <svg viewBox="0 0 1243 5" preserveAspectRatio="none">
              <rect class="line-track" width="1243" height="5" rx="2.5"></rect>
              <rect class="line-active" width="187.237" height="5" rx="2.5"></rect>
            </svg>
          </div>
          <div *ngIf="currentPath !== 'info'" class="card-body pt-9 pb-0">
            <div class="d-flex flex-wrap flex-sm-nowrap">
              <div class="me-7 mb-4">
                <div class="symbol symbol-160px symbol-fixed position-relative">
                  <input
                    type="file"
                    accept=".png, .jpeg, .jpg"
                    (change)="onFileSelected($event)"
                    style="display: none"
                    #fileInput
                  />

                  <img
                    [src]="previewImage || 'assets/media/profile/profile.svg'"
                    alt="image"
                    class="rounded-circle profile-photo-area"
                  />

                  <button
                    class="btn btn-icon btn-sm position-absolute profile-edit-icon cursor-pointer"
                    (click)="fileInput.click()"
                    title="{{ 'profile.editAvatar' | translate }}"
                  >
                    <img
                      src="assets/media/profile/picture-edit.svg"
                      alt="edit"
                      class="edit-svg"
                    />
                  </button>

                  <button
                    *ngIf="
                      previewImage &&
                      previewImage !== 'assets/media/profile/profile.svg'
                    "
                    class="btn btn-icon btn-sm position-absolute profile-delete-icon cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteAvatarModal"
                    title="{{ 'profile.deleteAvatar' | translate }}"
                  >
                    <i class="fa-solid fa-trash fs-7"></i>
                  </button>
                </div>
              </div>
              <div class="flex-grow-1">
                <div
                  class="d-flex justify-content-between align-items-start flex-wrap mb-2"
                >
                  <div class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-2">
                      <a
                        class="text-gray-900 text-hover-primary fs-2 fw-bold me-1"
                        style="cursor: default"
                      >
                        {{ fullName || "" }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="currentPath === 'info'" class="info-text p-6 pb-0">
            <div [innerHTML]="systemInformation?.information"></div>
          </div>
        </div>
        <div *ngIf="currentPath !== 'info'" class="card mb-5 mb-xxl-8">
          <p class="fs-6 text profile-header-text">
            {{ "profile.details" | translate }}
          </p>
          <div class="profile-header-line" aria-hidden="true">
            <svg viewBox="0 0 1243 5" preserveAspectRatio="none">
              <rect class="line-track" width="1243" height="5" rx="2.5"></rect>
              <rect class="line-active" width="187.237" height="5" rx="2.5"></rect>
            </svg>
          </div>
          <div class="card-body">
            <ul
              class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link text-gray-800 active"
                  data-bs-toggle="tab"
                  href="#general"
                  aria-selected="true"
                  role="tab"
                  (click)="setTitle('general')"
                  >{{ "profile.general" | translate }}</a
                >
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link text-gray-800"
                  data-bs-toggle="tab"
                  href="#authentication"
                  aria-selected="true"
                  role="tab"
                  (click)="setTitle('authentication')"
                  >{{ "profile.authentication" | translate }}</a
                >
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link text-gray-800"
                  data-bs-toggle="tab"
                  href="#password"
                  aria-selected="false"
                  role="tab"
                  (click)="setTitle('password')"
                  >{{ "profile.password" | translate }}</a
                >
              </li>
            </ul>

            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="general"
                role="tabpanel"
              >
                <form
                  [formGroup]="generalForm"
                  (ngSubmit)="save('generalForm')"
                >
                  <div class="col">
                    <div class="row g-4">
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputName">{{ "name" | translate }}</label>
                        <div class="form-floating-profile">
                          <input
                            formControlName="name"
                            type="text"
                            class="form-control"
                            id="inputName"
                            placeholder="Name"
                          />
                          <div
                            *ngIf="isControlInvalid('name')"
                            class="text-danger"
                          >
                            <ng-container
                              *ngIf="
                                generalForm.get('name').hasError('required')
                              "
                            >
                              {{ "nameIsRequired" | translate }}
                            </ng-container>
                            <ng-container
                              *ngIf="
                                !generalForm.get('name').hasError('required') &&
                                generalForm.get('name').hasError('onlyLetters')
                              "
                            >
                              {{ "nameMustContainOnlyLetters" | translate }}
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputSurname">{{
                          "surname" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <input
                            formControlName="surname"
                            type="text"
                            class="form-control"
                            id="inputSurname"
                            placeholder="Surname"
                          />
                          <div
                            *ngIf="isControlInvalid('surname')"
                            class="text-danger"
                          >
                            <ng-container
                              *ngIf="
                                generalForm.get('surname').hasError('required')
                              "
                            >
                              {{ "surnameIsRequired" | translate }}
                            </ng-container>
                            <ng-container
                              *ngIf="
                                !generalForm
                                  .get('surname')
                                  .hasError('required') &&
                                generalForm
                                  .get('surname')
                                  .hasError('onlyLetters')
                              "
                            >
                              {{ "surnameMustContainOnlyLetters" | translate }}
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputTel">{{
                          "phoneNumber" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <ngx-intl-tel-input
                            appPhoneInput
                            [cssClass]="'form-control'"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[
                              SearchCountryField.Iso2,
                              SearchCountryField.Name,
                            ]"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="defaultCountry"
                            [maxLength]="15"
                            [phoneValidation]="true"
                            [separateDialCode]="true"
                            name="phoneNumber"
                            formControlName="phoneNumber"
                          >
                          </ngx-intl-tel-input>
                          <div
                            *ngIf="isControlInvalid('phoneNumber')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="
                                generalForm.get('phoneNumber')?.errors?.[
                                  'required'
                                ]
                              "
                            >
                              {{ "phoneNumberIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="
                                generalForm.get('phoneNumber')?.errors?.[
                                  'validatePhoneNumber'
                                ]
                              "
                            >
                              {{ "phoneNumberIsNotValid" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputEmail">{{
                          "email" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <input
                            formControlName="email"
                            type="email"
                            class="form-control"
                            id="inputEmail"
                            [placeholder]="'email' | translate"
                          />
                          <div
                            *ngIf="isControlInvalid('email')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="
                                generalForm.get('email')?.errors?.['required']
                              "
                            >
                              {{ "emailIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="
                                generalForm.get('email')?.errors?.['email']
                              "
                            >
                              {{ "emailIsNotValid" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputLanguage">{{
                          "profile.language" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <app-select
                            formControlName="selectedLanguageCode"
                            [items]="languageService.getLanguages()"
                            bindLabel="name"
                            bindValue="code"
                            [clearable]="true"
                            appendTo="body"
                            [placeholder]="'profile.language' | translate"
                          >
                          </app-select>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end mt-8 gap-3">
                        <button
                          type="submit"
                          class="btn btn-sm btn-primary cursor-pointer"
                        >
                          {{ "update" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="tab-pane fade" id="authentication" role="tabpanel">
                <form [formGroup]="authForm">
                  <div class="col">
                    <div class="row g-4">
                      <div class="form-check form-switch mt-6">
                        <input
                          [(ngModel)]="googleAuthToggle"
                          [ngModelOptions]="{ standalone: true }"
                          class="form-check-input google-auth"
                          type="checkbox"
                          role="switch"
                          id="googleAuth"
                          [checked]="authForm.get('googleAuth')?.value"
                          (change)="onGoogleAuthToggle($event)"
                          [disabled]="authForm.get('googleAuth')?.disabled"
                        />
                        <label class="form-check-label" for="googleAuth">
                          {{
                            "profile.twoFactorAuthenticationLabel" | translate
                          }}
                        </label>
                      </div>

                      <div class="form-check form-switch mt-6">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="mailAuth"
                          [checked]="authForm.get('mailAuth')?.value"
                          (change)="onMailAuthToggle($event)"
                          [disabled]="authForm.get('mailAuth')?.disabled"
                        />
                        <label class="form-check-label" for="mailAuth">{{
                          "profile.mailAuthentication" | translate
                        }}</label>
                      </div>
                    </div>

                    <form
                      *ngIf="showMailSection"
                      [formGroup]="mailCodeForm"
                      (submit)="submitMailAuthCode($event)"
                      class="form w-100"
                      novalidate="novalidate"
                      id="kt_mail_auth_form"
                      action="#"
                    >
                      <div class="fw-semibold fs-4 mt-4">
                        {{ "profile.mailAuthentication" | translate }}
                      </div>
                      <div class="row">
                        <div class="col-md-3 mt-4">
                          <div class="form-floating">
                            <input
                              formControlName="code"
                              class="form-control"
                              id="inputCode"
                              type="text"
                              placeholder=""
                            />
                            <label for="inputCode">{{
                              "code" | translate
                            }}</label>
                            <div
                              *ngIf="isFirstLoginControlInvalid('code')"
                              class="text-danger"
                            >
                              <div
                                *ngIf="
                                  mailCodeForm.get('code')?.errors?.['required']
                                "
                              >
                                {{ "codeIsRequired" | translate }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mt-4">
                        <button
                          type="submit"
                          class="btn btn-primary cursor-pointer"
                          [disabled]="mailAuthSectionLoading"
                        >
                          <span class="indicator-label">
                            <ng-container
                              *ngIf="mailAuthSectionLoading; else showLoginText"
                            >
                              {{ "pleaseWait" | translate }}
                              <span
                                class="spinner-border spinner-border-sm align-middle ms-2"
                              ></span>
                            </ng-container>
                            <ng-template #showLoginText>
                              {{ "submit" | translate }}
                            </ng-template>
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </form>
              </div>

              <div class="tab-pane fade" id="password" role="tabpanel">
                <form [formGroup]="passwordForm" (ngSubmit)="changePassword()">
                  <div class="col">
                    <div class="row g-4">
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputCurrentPassword">{{
                          "profile.oldPassword" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <div class="position-relative">
                            <input
                              formControlName="currentPassword"
                              [type]="oldPasswordVisible ? 'text' : 'password'"
                              class="form-control"
                              id="inputCurrentPassword"
                              [placeholder]="'profile.oldPassword' | translate"
                              (input)="onCurrentPasswordChange()"
                            />
                            <i
                              class="bi position-absolute cursor-pointer"
                              [ngClass]="
                                oldPasswordVisible
                                  ? 'bi-eye-slash-fill'
                                  : 'bi-eye-fill'
                              "
                              style="
                                right: 15px;
                                top: 50%;
                                transform: translateY(-50%);
                              "
                              (click)="showPassword('oldPassword')"
                            ></i>
                          </div>
                          <!-- Frontend validation errors -->
                          <div
                            *ngIf="isPasswordControlInvalid('currentPassword')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="
                                passwordForm.get('currentPassword')?.errors?.[
                                  'required'
                                ]
                              "
                            >
                              {{ "alerts.oldPasswordRequired" | translate }}
                            </div>
                          </div>
                          <!-- Backend validation error -->
                          <div *ngIf="currentPasswordError" class="text-danger">
                            {{ currentPasswordError }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputNewPassword">{{
                          "newPassword" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <div class="position-relative">
                            <input
                              formControlName="newPassword"
                              [type]="newPasswordVisible ? 'text' : 'password'"
                              class="form-control"
                              id="inputNewPassword"
                              [placeholder]="'newPassword' | translate"
                            />
                            <i
                              class="bi position-absolute cursor-pointer"
                              [ngClass]="
                                newPasswordVisible
                                  ? 'bi-eye-slash-fill'
                                  : 'bi-eye-fill'
                              "
                              style="
                                right: 15px;
                                top: 50%;
                                transform: translateY(-50%);
                              "
                              (click)="showPassword('newPassword')"
                            ></i>
                          </div>
                          <div
                            *ngIf="
                              isPasswordControlInvalid('newPassword') ||
                              (passwordForm.errors?.['sameAsCurrentPassword'] &&
                                passwordForm.get('newPassword')?.touched)
                            "
                            class="text-danger"
                          >
                            <!-- Required validation -->
                            <div
                              *ngIf="
                                passwordForm.get('newPassword')?.errors?.[
                                  'required'
                                ]
                              "
                            >
                              {{ "alerts.newPasswordRequired" | translate }}
                            </div>

                            <!-- Password strength validations -->
                            <div
                              *ngIf="
                                !passwordForm.get('newPassword')?.errors?.[
                                  'required'
                                ] &&
                                passwordForm.get('newPassword')?.errors?.[
                                  'minLength'
                                ]
                              "
                            >
                              {{ "alerts.passwordMinLength" | translate }}
                            </div>
                            <div
                              *ngIf="
                                !passwordForm.get('newPassword')?.errors?.[
                                  'required'
                                ] &&
                                passwordForm.get('newPassword')?.errors?.[
                                  'maxLength'
                                ]
                              "
                            >
                              {{ "alerts.passwordMaxLength" | translate }}
                            </div>
                            <div
                              *ngIf="
                                !passwordForm.get('newPassword')?.errors?.[
                                  'required'
                                ] &&
                                passwordForm.get('newPassword')?.errors?.[
                                  'uppercase'
                                ]
                              "
                            >
                              {{
                                "alerts.passwordRequiresUppercase" | translate
                              }}
                            </div>
                            <div
                              *ngIf="
                                !passwordForm.get('newPassword')?.errors?.[
                                  'required'
                                ] &&
                                passwordForm.get('newPassword')?.errors?.[
                                  'lowercase'
                                ]
                              "
                            >
                              {{
                                "alerts.passwordRequiresLowercase" | translate
                              }}
                            </div>
                            <div
                              *ngIf="
                                !passwordForm.get('newPassword')?.errors?.[
                                  'required'
                                ] &&
                                passwordForm.get('newPassword')?.errors?.[
                                  'number'
                                ]
                              "
                            >
                              {{ "alerts.passwordRequiresNumber" | translate }}
                            </div>
                            <div
                              *ngIf="
                                !passwordForm.get('newPassword')?.errors?.[
                                  'required'
                                ] &&
                                passwordForm.get('newPassword')?.errors?.[
                                  'specialChar'
                                ]
                              "
                            >
                              {{
                                "alerts.passwordRequiresSpecialChar" | translate
                              }}
                            </div>

                            <!-- Same as current password warning -->
                            <div
                              *ngIf="
                                !passwordForm.get('newPassword')?.errors &&
                                passwordForm.errors?.[
                                  'sameAsCurrentPassword'
                                ] &&
                                passwordForm.get('newPassword')?.touched
                              "
                              class="text-warning"
                            >
                              {{ "alerts.newOldPasswordCheck" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputConfirmPassword">{{
                          "profile.confirmPassword" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <div class="position-relative">
                            <input
                              formControlName="confirmNewPassword"
                              [type]="
                                confirmPasswordVisible ? 'text' : 'password'
                              "
                              class="form-control"
                              id="inputConfirmPassword"
                              [placeholder]="
                                'profile.confirmPassword' | translate
                              "
                            />
                            <i
                              class="bi position-absolute cursor-pointer"
                              [ngClass]="
                                confirmPasswordVisible
                                  ? 'bi-eye-slash-fill'
                                  : 'bi-eye-fill'
                              "
                              style="
                                right: 15px;
                                top: 50%;
                                transform: translateY(-50%);
                              "
                              (click)="showPassword('confirmPassword')"
                            ></i>
                          </div>
                          <div
                            *ngIf="
                              isPasswordControlInvalid('confirmNewPassword') ||
                              (passwordForm.errors?.['passwordMismatch'] &&
                                passwordForm.get('confirmNewPassword')?.touched)
                            "
                            class="text-danger"
                          >
                            <div
                              *ngIf="
                                passwordForm.get('confirmNewPassword')
                                  ?.errors?.['required']
                              "
                            >
                              {{ "alerts.confirmPasswordRequired" | translate }}
                            </div>
                            <div
                              *ngIf="
                                !passwordForm.get('confirmNewPassword')
                                  ?.errors?.['required'] &&
                                passwordForm.errors?.['passwordMismatch']
                              "
                            >
                              {{ "alerts.passwordsDoNotMatch" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-end mt-8 gap-3">
                        <button
                          type="submit"
                          class="btn btn-sm btn-primary cursor-pointer"
                          [disabled]="passwordForm.invalid"
                        >
                          {{ "update" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="createGoogleQrCodeModal"
  tabindex="-1"
  aria-labelledby="createGoogleQrCodeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="createGoogleQrCodeModalLabel">
          {{ "profile.twoFactorAuthenticationTitle" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4 text-center">
        <ng-container *ngIf="isGoogleChecked">
          <div
            *ngIf="!googleQrCodeDetails?.qrCodeImageUrl; else showQrCode"
            class="spinner-border qr-code-spinner text-danger"
            role="status"
          >
            <span class="visually-hidden">{{ "loading" | translate }}...</span>
          </div>
        </ng-container>

        <ng-template #showQrCode>
          <img
            [src]="googleQrCodeDetails.qrCodeImageUrl"
            class="w-100"
            alt="QR Code"
          />
        </ng-template>

        <form
          [formGroup]="googleQrCodeForm"
          (submit)="submitGoogleQrCodeForm($event)"
          class="form w-100"
          novalidate="novalidate"
          id="kt_google_qr_form"
          action="#"
        >
          <p class="fs-6 mt-3 mb-2" *ngIf="!isGoogleChecked">
            {{ "profile.enterCodeToDisable" | translate }}
          </p>

          <p class="fs-6 mb-2" *ngIf="isGoogleChecked">
            {{ "profile.scanQrCodeText" | translate }}
          </p>

          <div class="form-floating mt-4">
            <input
              formControlName="code"
              class="form-control"
              id="inputGoogleCode"
              type="text"
              placeholder=""
            />
            <label for="inputGoogleCode">{{ "code" | translate }}</label>
            <div
              *ngIf="
                googleQrCodeForm.get('code')?.invalid &&
                googleQrCodeForm.get('code')?.touched
              "
              class="text-danger"
            >
              <div
                *ngIf="googleQrCodeForm.get('code')?.errors?.['invalidCode']"
              >
                {{ "invalidCode" | translate }}
              </div>
            </div>
          </div>
          <div class="d-grid mb-10 mt-4">
            <button type="submit" class="btn btn-primary cursor-pointer">
              <span class="indicator-label">
                {{ "submit" | translate }}
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Delete Avatar Modal -->
<div
  class="modal fade"
  id="deleteAvatarModal"
  tabindex="-1"
  aria-labelledby="deleteAvatarModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="deleteAvatarModalLabel">
          {{ "profile.deleteAvatar" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ "profile.deleteAvatarConfirm" | translate }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary cursor-pointer"
          (click)="deleteAvatar()"
          data-bs-dismiss="modal"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
